import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Map from 'eemovel-map-library/src/data/google-maps/map';

import { Select } from '../../component';
import { allFirstLettersToUpperCase } from '../../helpers/textFormatter';
import { changeCity, initialCity } from './controllers/citySelect.controller';
import { setCityList, setSelectedCity } from './redux/mapSearch.reducer';
import { ICity } from './types/mapSearch.types';

function CitySelect() {
  const dispatch = useDispatch();
  const { selectedCity, cityList } = useSelector(
    (state: any) => state.mapSearch
  );

  useEffect(() => {
    if (Map.map && !!selectedCity.name) {
      changeCity(selectedCity);
    }
  }, [selectedCity]);

  const onChangeCitySelectAction = useCallback(
    (event: any) => {
      const newCity = cityList.find(
        (city: ICity) => city.id === event.value.id
      );
      dispatch(setSelectedCity(newCity));
    },
    [cityList]
  );

  const cityUF = useCallback(
    ({ name, uf }: { name: string; uf?: string }): string =>
      `${allFirstLettersToUpperCase(name)}${uf ? ' - ' + uf : ''}`,
    []
  );

  const handleCitySearch = useCallback(
    (_: any, search: string) => {
      const bestMatch = cityList.filter(({ name, uf }: any) => {
        const cityFullName = cityUF({ name, uf }).toLocaleLowerCase();
        const searchLowerCase = search.toLowerCase();
        return cityFullName.includes(searchLowerCase);
      });
      setCityList(bestMatch);
    },
    [cityList]
  );

  return cityList && selectedCity ? (
    <Select
      cy="ChangeCity"
      label=""
      name="city"
      action={onChangeCitySelectAction}
      actionFilter={handleCitySearch}
      options={cityList}
      selected={selectedCity}
      closeOnSelect={true}
      selectedItem={false}
      filter
      optionLabel="name"
      optionValue="id"
      optionCustom={cityUF}
      labelCustom={cityUF}
    />
  ) : null;
}

export default CitySelect;
